import { render, staticRenderFns } from "./UserChannelsHome.vue?vue&type=template&id=692678a8&scoped=true&"
import script from "./UserChannelsHome.ts?vue&type=script&lang=ts&"
export * from "./UserChannelsHome.ts?vue&type=script&lang=ts&"
import style0 from "./UserChannelsHome.vue?vue&type=style&index=0&id=692678a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692678a8",
  null
  
)

export default component.exports